import React, { useState, useContext, useEffect } from 'react'
import StateContext from '../../state/stateContext';
import { SelectList } from "slide-ui";
import { capitalizeFirstLetter } from '../../helpers/helpers';

const CategoryFilter = (props) => {
  const initialCat = props.selectedCategory ? props.selectedCategory : "all";
  const [category, setCategory] = useState(initialCat);
  const { state, dispatch } = useContext(StateContext);
  const { feedCategories } = state;

  useEffect(() => {
    dispatch({ type: "setCategory", payload: category });
  }, [category]);

  const selectListData = {
    classList: "feed-filter-wrapper",
    sendItem(item) {
      setCategory(item.key);
    },
    hasButton: false
  };

  const getCategoryIndexByFilterString = (categories, filterString) => {
    let index = -1;
    for(let i=0; i < categories.length; i++) {
       if (categories[i].key === filterString ) {
        index =  i;
       }
     };
    return index;
   
  }

  // format photo to Photo
  const formatCustomFilterValue = (filter) => {
    return capitalizeFirstLetter(filter.replace(":", " ")); 
  }


  const formCategoryListData = () => {
    let categoryList = [
      { key: "all", value: "All" }
    ];

    Object.keys(feedCategories).forEach((actor) => {
      categoryList.push({ key: actor, value: formatFilterValues(actor) });
        feedCategories[actor].forEach((type => {
            const formattedValue = formatFilterValues(type);
            categoryList.push({ key: `${actor}:${type}`, value: formattedValue })
        }));
    });

    return categoryList;
  }
    
  const formatFilterValues = (type) => {
    let formattedType = type.charAt(0).toUpperCase() + type.slice(1);
        
    if (!["child", "adp", "country"].includes(type)) {
      formattedType = `${formattedType}s`;
    }

    if (type === "adp") {
      formattedType = "Community";
    }
    return formattedType;
  }

  const validCustomFilters = (initialCat) => {
    const validCat = ['all', 'child:letter', 'child:video', 'child:photo','adp:accomplishment', 'adp:video', 'adp:photo', 'adp:letter', 'adp:prayer request','child', 'country:prayer request', 'community', 'country', 'child','adp', 'video', 'photo', 'letter', 'accomplishment', 'prayer request' ];
    return validCat.includes(initialCat); 
  }



  // set the select list to "Filter By Category", unless a category was passed in as a query string param. 
  const initialIndex = getCategoryIndexByFilterString(formCategoryListData(), initialCat);
  if (!validCustomFilters(initialCat)) {
    selectListData.initialInputValue = "-";
  }
  else if (initialIndex < 0) {
    selectListData.initialInputValue = formatCustomFilterValue(initialCat);
  } else if (initialIndex === 0) {
    selectListData.initialInputValue = "Filter By Category"; 
  } else {
    selectListData.initialIndex = initialIndex; 
  }
  
  
  return (
    <SelectList {...selectListData}>
    {formCategoryListData().map((item) => {
      return <span key={`${item.key}`} className={!["all", "child", "community", "country"].includes(item.value.toLowerCase()) ? "sub-item" : ""}>{`${item.value}`}</span>;
    })}
    </SelectList>
  )
}

export default CategoryFilter;
